module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("From Istanbul to Haifa")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#authors-word"
    }
  }, [_vm._v("Author’s Word")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#prologue"
    }
  }, [_vm._v("Prologue")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#the-letter"
    }
  }, [_vm._v("The Letter")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0002#waiting-for-a-signal"
    }
  }, [_vm._v("Waiting for a Signal")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0003#everything-from-palestine-is-different"
    }
  }, [_vm._v("Everything from Palestine Is Different")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#part-i"
    }
  }, [_vm._v("Part I")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0005#the-god-father-1"
    }
  }, [_vm._v("The God Father (1)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0006#greece-2"
    }
  }, [_vm._v("Greece (2)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0007#the-escape-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Escape (3)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0008#the-black-sea-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Black Sea (4)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0009#a-new-role-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Role (5)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0010#from-palestine-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Palestine (6)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#forever-departing-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forever Departing (7)")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#part-ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-police-chief-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Police Chief (1)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0015#istanbul-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Istanbul (2)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0016#the-beginning-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beginning (3)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0017#damascus-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Damascus (4)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0019#the-imperative-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Imperative (5)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0020#the-establishment-of-the-state-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Establishment of the State (6)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0023#damascus-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Damascus (7)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0024#the-post-wars-toiling-troubles-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Post-War’s Toiling Troubles (8)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0027#haifa-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haifa (9)")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#part-iii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0028#the-historian-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Historian (1)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0029#the-birth-of-an-arab-society-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Birth of an Arab Society (2)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0030#the-arab-youth-organisation-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Arab Youth Organisation (3)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0030#al-fatat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(Al Fatat)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0032#to-beirut-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Beirut (4)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0033#the-book-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Book (5)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0034#bab-idris-beirut-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bab Idris Beirut (6)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0035#shadows-over-syira7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shadows Over Syira(7)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0036#diplomacy-and-density8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diplomacy and Density(8)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0038#the-conference-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Conference (9)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0041#to-haifa-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Haifa (10)")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#part-iv",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0042#the-consular-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Consular (1)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0043#the-birth-of-national-consciousness2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Birth of National Consciousness(2)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0046#faith-and-walls-in-beruit3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith and Walls in Beruit(3)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0047#arabisation-and-turkification4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arabisation and Turkification(4)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0048#corssroads5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corssroads(5)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0049#damascus6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Damascus(6)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0050#haifa-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haifa (7)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0051#st-jamess-standoff-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1921 St James’s standoff (8)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0053#zionism-and-arabs-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zionism and Arabs (9)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0054#the-palestinian-exodus-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Palestinian Exodus (10)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0056#the-crash-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crash (11)")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#part-v",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part V")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0058#the-doctor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Doctor (1)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0059#the-dream-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dream (2)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0060#the-exile-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Exile (3)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0061#mediation-in-egypt-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mediation in Egypt (4)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0062#the-news-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The News (5)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0065#damascus-mezzeh-area-5-september-20216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Damascus, Mezzeh Area, 5 September 2021(6)")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#references",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c6ea71c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0